import { push } from 'connected-react-router';
import get from 'lodash/get';

import { getAuthMe } from 'common/api/v1/auth';
import { initProfileConfigurationActions } from 'common/utils/helpers/multiregion';
import { initSessionActions } from 'common/utils/helpers/session';

import setCurrentValues from '../../profile/actions/setCurrentValues';
import setTheme from '../../profile/actions/setTheme';
import updateConfiguration from '../../profileConfiguration/actions/updateConfiguration';
import {
    FETCH_DATA,
    FETCH_DATA_FAILURE,
    FETCH_DATA_SUCCESS,
} from '../actionTypes';
import { createAccountActions } from '../reducer';

export default (callback) => (dispatch) => {
    dispatch(createAccountActions[FETCH_DATA]());

    getAuthMe()
        .then((response) => {
            const data = get(response, 'data.data', {});
            dispatch(createAccountActions[FETCH_DATA_SUCCESS](data));
            localStorage.setItem('session', JSON.stringify(data));
            initSessionActions((data) => dispatch(setCurrentValues(data)));
            initProfileConfigurationActions((data) =>
                dispatch(updateConfiguration(data)),
            );

            if (data.settings !== null) {
                if (data.settings?.mode)
                    dispatch(setTheme(data.settings.mode.toLowerCase()));

                localStorage.setItem(
                    'selectedDrawerSize',
                    data.settings.expanded_sidebar ? 'normal' : 'small',
                );
            }
            callback();
            dispatch(push('/projects'));
        })
        .catch((error) =>
            dispatch(
                createAccountActions[FETCH_DATA_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
